__turbopack_context__.v({
  "controls": "controls-module-scss-module__ZPoAJG__controls",
});
